import { render, staticRenderFns } from "./SpclCtgry.vue?vue&type=template&id=29fb353e&scoped=true"
import script from "./SpclCtgry.vue?vue&type=script&lang=js"
export * from "./SpclCtgry.vue?vue&type=script&lang=js"
import style0 from "./SpclCtgry.vue?vue&type=style&index=0&id=29fb353e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fb353e",
  null
  
)

export default component.exports